<template>
  <div>
    <v-layout wrap>
      <v-flex xl6 lg7 md12>
        <LineChart :id="type||'ebit'"
        :datasets.sync="dataBar.datasets"
          :labels.sync="dataBar.labels"
          :onClick="(ev, array) => openModalBar(ev, array)"/> 
      </v-flex>

      <v-flex xl5 offset-xl1 lg5 offset-lg0 md6 offset-md3 class="px-4">
        
        <div style="text-align: end;">
          <v-btn color="secondary"  @click="exportExcel" v-if="myPermissions.includes(17)" :style="dark_t?'color:black':''">
            <v-icon></v-icon>
            <span>Exportar Excel</span>
          </v-btn>
        </div>

        <v-data-table
          :footer-props="{'items-per-page-options': [5,10,25, -1],'items-per-page-text':'Filas por pagina'}"
          :headers="headers"
          :options.sync="pagination"
          :items="array"
          class="tablaLT1"
          :sort-by="['fiscal_year']"
          :sort-desc="[true]"
          :class="dark_t?'dark':''">
          <template v-slot:item="props">
            <tr>
              <td><fs1-span>{{ props.item.fiscal_year }}</fs1-span></td>
              <td><fs1-span>{{ props.item.impacted_area_name }}</fs1-span></td>
              <td><fs1-span>{{ props.item.value }}</fs1-span></td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-icon>warning</v-icon>
            Sin Información.
          </template>
        </v-data-table>
        
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import LineChart from '@/components/graphs/Line.vue';
import { mapGetters } from 'vuex';
import { getExportEbits  as exportExcel } from '@/requests/ac';
import { even } from '@/functions/general.js';


const getEbitByYear = (ebits, y) => {
  const ebit = ebits.find(f => f.fiscal_year === y);
  return ebit ? ebit.value || null: null;
}
const color = ['rgb(255, 99, 132)',
  'rgb(54, 162, 235)',
  'rgb(255, 206, 86)',
  'rgb(75, 192, 192)',
  'rgb(153, 102, 255)',
  'rgb(255, 159, 64)'];

export default {
  props: ['type'],
  data() {
    return {
      pagination: {sortDesc: true, page: 1, itemsPerPage: 5, totalItems: 0 },
    };
  },
  computed: {
    ...mapGetters({
      listImpactedAreas: 'listImpactedAreas',
      ebits: 'ebits',
    }),
    array() {
      let array = this.ebits.filter(e => {
        if (this.type=='EBITDA' && e.fiscal_year < 2023) return;
        if (this.type!='EBITDA' && e.fiscal_year > 2022) return;
        const ia = this.listImpactedAreas.find(f => f.id === e.impacted_area);
        e.impacted_area_name = ia ? ia.name : '';
        return e;
      });
      this.pagination.totalItems = array.length;
      return array;
    },
    dataBar() {
      let years = this.array.length ? even(this.array, 'fiscal_year') : this.array;
      years = years.map(m => m.fiscal_year);
      years = years.unique();
      const dataBar = {labels: [], datasets: []};
      const datas = {};
      this.listImpactedAreas.forEach(a => datas[a.id] = []);

      years.forEach(y => {
        dataBar.labels.push(y);
        this.listImpactedAreas.forEach(a => {
          datas[a.id].push(getEbitByYear(a.ebits, y)|| null);
        })
      });

      this.listImpactedAreas.forEach((a,i) => {
        dataBar.datasets.push({
          label: a.full_name,
          fill: false,
          data: datas[a.id],
          backgroundColor: color[i],
          borderColor: color[i],
        })
      });
      
      return dataBar;
    },
    headers() {
      return [
				{ text: 'Año fiscal', value: 'fiscal_year', sortable:false },
				{ text: 'Área', value: 'impacted_area_name', sortable:false },
				{ text: 'EBIT', value: 'value', sortable:false },
			];
    },
  },
  components: {  LineChart },
  watch: { },
  methods: {
		async exportExcel(){
      this.setProgress({show:true,message:'Cargando...'});
			if(!await this.assignAccess()) return;
			exportExcel(this.filter)
        .then(r => this.setProgress({show:false}))
        .catch(e => this.getError(e));
		},
  },
};
</script>
